import {
  moduleNamespace,
  SET_CURRENT_STEP,
  SET_ERRORS,
  SET_INCOMPLETE_CONFIGURATION,
  SET_REGISTRATION_FIELD,
  SET_WHITELABEL_LOGO,
  SET_WHITELABEL_STATUS,
  TOGGLE_TAX,
  UPDATE_TAX_RATE_PERCENTAGE,
  SET_COUNTRIES,
  UPDATE_COUNTRIES,
  SET_FORM_FIELD,
  SET_LOADING_STATE, SET_STRIPE_ACCOUNT_ERROR,
  SET_WHITELABEL_CUSTOM_DOMAIN_MESSAGE,
} from "./constants";
import {
  writeSoftwareProductToSession,
  writeSupportAddonToSession
} from '../productManager/methods';
import {moduleNamespace as productManagerModuleNamespace} from '../productManager/constants';
import {moduleNamespace as addonManagerModuleNamespace} from '../addonManager/constants';
import {writeAddonsToSession} from "../addonManager/methods";
import {writeSession} from "../../sharedGlobal";
import {writeRegistrationToSession, writeTaxConfigToSession} from "./methods";
import {captureException} from "../../../errorHelper";

export default {
  [SET_WHITELABEL_STATUS]: (state, payload) => {
    const { custom_domain_status, custom_email_status } = payload;
    state.customDomainStatus = custom_domain_status;
    state.customEmailStatus = custom_email_status;
  },
  [SET_CURRENT_STEP]: (state, payload) => {
    state.currentStep = payload;
    writeSession(moduleNamespace, 'currentStep', payload);
  },
  [SET_WHITELABEL_CUSTOM_DOMAIN_MESSAGE]: (state, payload) => {
    state.whitelabelCustomDomainMessage = payload;
  },
  [SET_ERRORS]: (state, { errors, namespace, joi }) => {
    if (joi === true) {
      // Flattening the Joi error format into dot-notation keyed errors
      errors.reduce((total, e) => {
        const { message, path } = e;
        path.unshift(namespace);
        total[path.join('.')] = message;
        return total;
      }, state.errors);

      return;
    }

    // Flattening the Laravel error format to <br> separated strings
    let flattenedErrors = {};
    for (const [field, fieldErrors] of Object.entries(errors)) {
      const errorKey = [namespace, field].join('.');
      flattenedErrors[errorKey] = fieldErrors.join('<br>');
    }

    state.errors = flattenedErrors;
  },
  [SET_INCOMPLETE_CONFIGURATION]: (state, {rootState, payload}) => {
    if (payload === null) {
      return;
    }

    try {
      const {
        incompleteSoftware,
        incompleteSupportAddon,
        incompleteAddons,
        enabledCurrencies,
      } = payload;

      enabledCurrencies.forEach(({currency}) => {
        rootState[productManagerModuleNamespace].supportedCurrencies[currency] = {
          ...rootState[productManagerModuleNamespace].supportedCurrencies[currency],
          enabled: true,
        };
      });

      rootState[productManagerModuleNamespace].softwareProduct = incompleteSoftware;
      writeSoftwareProductToSession(incompleteSoftware);

      rootState[productManagerModuleNamespace].supportAddon = incompleteSupportAddon;
      writeSupportAddonToSession(incompleteSupportAddon);
      enabledCurrencies.forEach(({currency}) => {
        if (
          incompleteSupportAddon.prices[currency].monthlyRaw > 0 ||
          incompleteSupportAddon.prices[currency].annualRaw > 0
        ) {
          rootState[productManagerModuleNamespace].enableSupportAddon = true;
        }
      });

      rootState[addonManagerModuleNamespace].addons = incompleteAddons;
      writeAddonsToSession(incompleteAddons);
    } catch (e) {
      captureException(e, {
          'payload': payload,
      });
    }
  },
  [SET_REGISTRATION_FIELD]: (state, field) => {
    state.registration = Object.assign(
      {},
      state.registration,
      field
    );
    // TODO: Could these be in the actions as commit.then(dispatch('storeXyz'))?
    writeRegistrationToSession(state.registration);
  },
  [SET_WHITELABEL_LOGO]: (state, src) => state.whitelabelLogo = src,
  [TOGGLE_TAX]: (state) => {
    state.taxConfig = {
      charging: !state.taxConfig.charging,
      percentage: 0,
      countries: [],
    };
    // TODO: Could these be in the actions as commit.then(dispatch('storeXyz'))?
    writeTaxConfigToSession(state.taxConfig);
  },
  [UPDATE_TAX_RATE_PERCENTAGE]: (state, value) => {
    state.taxConfig = {
      ...state.taxConfig,
      percentage: value,
    };
    // TODO: Could these be in the actions as commit.then(dispatch('storeXyz'))?
    writeTaxConfigToSession(state.taxConfig);
  },
  [SET_COUNTRIES]: (state, countries) => state.countries = countries,
  [UPDATE_COUNTRIES]: (state, countries) => {
    state.taxConfig.countries = countries;
    // TODO: Could these be in the actions as commit.then(dispatch('storeXyz'))?
    writeTaxConfigToSession(state.taxConfig);
  },
  [SET_FORM_FIELD]: (state, field) => {
    state.formFields = {
      ...state.formFields,
      ...field,
    };
    // TODO: Write to session
  },
  [SET_LOADING_STATE]: (state, boolean) => state.loading = boolean,
  [SET_STRIPE_ACCOUNT_ERROR]: (state, error) => state.stripeAccountError = error,
};
